<template>
  <div class="ReportList">
    <h2 style="font-size: 24px; color: #262626; font-weight: bold;">游戏报告</h2>
    <div class="reportView">
      <div>
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="个体报告" key="1"><game-personal-report/></a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import GamePersonalReport from './GamePersonalReport'
  export default {
    name: 'ReportList',
    components: {
			GamePersonalReport
		}
  }
</script>

<style>
.ReportList{
  width: 976px;
}
.ReportList>p{
  font-size:24px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:24px;
}
.ReportList .reportView{
  margin-top: 24px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(232,232,232,1);
}
.ReportList .reportView .ant-tabs-ink-bar{
  width: 56px;
  background-color: #51BF94;
}
.ant-tabs-nav .ant-tabs-tab-active {
	color: #262626;
	font-weight: 500;
}
.ant-table-pagination.ant-pagination {
  float: right;
  margin: 16px 16px;
}
</style>